import { styled } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";

export const Drawer = styled(MuiDrawer)(() => ({}));
